import React from "react";
import style from "./index.module.scss";
import { workState } from "../../../../../API";

interface ItemStatusProps {
    status: workState;
}

export default function ItemStatus({ status }: ItemStatusProps) {
    if (status === workState.NoHomework) {
        return null;
    }

    if (status === workState.HaveHomework) {
        return <span className={style.HaveHomework}>待提交</span>;
    }

    if (status === workState.NotMark) {
        return <span className={style.NotMark}>待批阅</span>;
    }

    if (status === workState.Done) {
        return <span className={style.Done}>已批阅</span>;
    }

    return <span className={style.Overtime}>已过期</span>;
}
